export enum VideoStatus {
  noneStr = 'none',
  uploadErrorStr = 'upload_error',
  publishedStr = 'published',
  imagesPublishedStr = 'images_published',
  videoPublishedStr = 'video_published',
  removed = 'removed',
  pendingRemovalStr = 'pending_removal',
}

export enum MediaStatusEnum {
  None = 0,
  UploadError = 2,
  ImagesPublished = 6,
  VideosPublished = 7,
  Published = 4,
  Removed = 9,
  PendingRemoval = 8,
}

export const MediaStatusToVideoStatus = {
  [MediaStatusEnum.None]: VideoStatus.noneStr,
  [MediaStatusEnum.ImagesPublished]: VideoStatus.imagesPublishedStr,
  [MediaStatusEnum.VideosPublished]: VideoStatus.videoPublishedStr,
  [MediaStatusEnum.Published]: VideoStatus.publishedStr,
  [MediaStatusEnum.Removed]: VideoStatus.removed,
  [MediaStatusEnum.UploadError]: VideoStatus.uploadErrorStr,
  [MediaStatusEnum.PendingRemoval]: VideoStatus.pendingRemovalStr,
};

export enum EventArtifacts {
  ContextImage = 'context_image',
  AlprImage = 'alpr_image',
  Ublox = 'ublox',
  Metadata = 'metadata',
  JiPredictions = 'ji_predictions',
  ContextVideo = 'context_video',
  LPRVideo = 'lpr_video',
}
